import {Ad} from "./ad";
import {IframeManager} from "./iframeManager";

export class Error extends Ad {

    constructor(context, containerId, parameters, ad) {
        super(context, containerId, parameters, ad);
        if(typeof this.parameters.onError === 'function') {
            this.parameters.onError(this.ad);
        }
    }

    build() {
        this.container.style.display = 'none';
        this.container.innerHTML = "";

        if (this.parameters.backfillhtml && this.parameters.reveal) {
            this.container.innerHTML = this.ad.error;
        } else if (this.parameters.backfillhtml) {
            this.container.style.display = 'none';
            this.container.style.position = "absolute";
            this.container.style.left = "0px";
            this.container.style.top = "0px";
            this.container.style.width = window.innerWidth + "px";
            this.container.style.height = window.innerHeight + "px";

            const htmlBackFill = '<!DOCTYPE html>' +
                '<html>' +
                    '<head>' +
                        '<meta name="viewport" content="width=device-width, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0">' +
                        '<style>* { -webkit-tap-highlight-color: rgba(0,0,0,0);} img {width:100%} body {margin: 0; padding: 0}</style>' +
                    '</head>' +
                    '<body style="margin:0;padding:0;">' + this.parameters.backfillhtml + '</body>' +
                '</html>';
            const iframeManager = new IframeManager(this);
            let iframe = iframeManager.build();
            this.container.appendChild(iframe);
            iframeManager.addContent(htmlBackFill);
            this.container.style.display = 'block';
        }
    }

}
